// api/orderAPI.js
import axiosInstance from './axiosConfig';

const orderAPI = {
  /**
   * Create a new sales order
   * @param {object} orderData - Complete order data
   * @returns {Promise} Created order
   */
  create: async (orderData) => {
    try {
      const response = await axiosInstance.post('/orders', orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create order';
    }
  },

  /**
   * Create invoice from sales order
   * @param {string} orderId - Order ID to create invoice from
   * @returns {Promise} Created invoice
   */
  createInvoice: async (orderId) => {
    try {
      const response = await axiosInstance.post(`/orders/${orderId}/create-invoice`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create invoice from order';
    }
  },

  /**
   * Print order receipt
   * @param {string} orderId - Order ID to print
   * @returns {Promise} Print job status
   */
  printReceipt: async (orderId) => {
    try {
      const response = await axiosInstance.post(`/orders/${orderId}/print`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to print receipt';
    }
  },

  /**
   * Void an existing order
   * @param {string} orderId - Order ID to void
   * @returns {Promise} Voided order
   */
  voidOrder: async (orderId) => {
    try {
      const response = await axiosInstance.put(`/orders/${orderId}/void`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to void order';
    }
  },

  /**
   * Get all sales orders with optional filters
   * @param {object} params - Query parameters (populate, status, etc.)
   * @returns {Promise} List of orders
   */
  getAll: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/orders', { params });

      console.log('get all orders', response.data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch orders';
    }
  },

  /**
   * Get a specific order by ID
   * @param {string} orderId - Order ID to retrieve
   * @returns {Promise} Order details
   */
  getById: async (orderId) => {
    try {
      const response = await axiosInstance.get(`/orders/${orderId}`);
      
      return response.data;
    } catch (error) {  
      throw error.response?.data?.message || 'Failed to fetch order';
    }
  },

  updateStatus: async (orderId, data) => {
    try {
      const response = await axiosInstance.patch(`/orders/${orderId}/status`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update order status';
    }
  },

  cancel: async (orderId) => {
    try {
      const response = await axiosInstance.patch(`/orders/${orderId}/status`, { 
        status: 'cancelled' 
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to cancel order';
    }
  },
  
  // Return order
  returnOrder: async (orderId, returnData) => {
    const response = await axiosInstance.post(`/orders/${orderId}/return`, returnData);
    return response.data;
  },

  // In orderAPI.js - add getReturnOrders method
  getReturnOrders: async (id) => {
    try {
      const response = await axiosInstance.get(`/orders/${id}/returns`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch return orders';
    }
  },

  updateOrderDate: async (orderId, { date }) => {
    const response = await axiosInstance.put(`/orders/${orderId}/date`, { date });
    return response.data;
  },

  getDailySales: async (dateRange) => {
    try {
      const response = await axiosInstance.get('/orders/daily-sales', { 
        params: dateRange 
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch daily sales';
    }
  },

  getProductSales: async (dateRange) => {
    try {
      const response = await axiosInstance.get('/orders/product-sales', { 
        params: dateRange 
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch product sales';
    }
  },

  getSalesByDate: async (params) => {
    try {
      const response = await axiosInstance.get('/orders/sales-by-date', { 
        params 
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch sales by date';
    }
  },
  cancel: async (orderId, cancelData) => {
    try {
      const response = await axiosInstance.post(`/orders/${orderId}/cancel`, cancelData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to cancel order';
    }
  }
};

export default orderAPI;